import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Dropdown from '@comp/Dropdown/Dropdown';
import { useMemo, useState } from 'react';
import Button from 'aquilla/core/molecules/Button';
import { updateUserDetails } from '@api/fetchers/auth';

const CheckoutStateSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  width: 100%;
`;

const TopStateInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_1B};
`;

const StyDropdown = styled(Dropdown)`
  width: 100%;
  height: ${Spacings.SPACING_12B};
`;

const DropDownWrapper = styled.div<{ $noOptionSelected: boolean }>`
  display: flex;
  width: 100%;
  & > button {
    color: ${({ $noOptionSelected }) =>
      $noOptionSelected && 'var(--color-i-gray-13)'};
    border-color: ${({ $noOptionSelected }) =>
      $noOptionSelected && 'var(--color-i-divider)'};
    font-size: ${Fonts.H6};
    font-weight: ${Fonts.LIGHT};
  }
`;

const StyButton = styled(Button)`
  position: absolute;
  width: calc(100% - 32px);
  bottom: ${Spacings.SPACING_4B};
  height: ${Spacings.SPACING_12B};
`;

const CheckoutStateSelect = ({ states, setIsStateSelected }) => {
  const [selectedState, setSelectedState] = useState('default');

  const noOptionSelected = selectedState === 'default';

  const stateOptions = useMemo(() => {
    const stateOptionsArr = states.map((stateData) => ({
      label: stateData.name,
      value: stateData.code
    }));
    return [
      { label: 'Select the state of residence', value: 'default' },
      ...stateOptionsArr
    ];
  }, [states]);

  const submitStateSelection = () => {
    updateUserDetails({
      state_code: selectedState
    });
    setIsStateSelected(true);
  };

  return (
    <>
      <CheckoutStateSelectWrapper>
        <TopStateInfoWrapper>
          <Typography variant="h2">Add your state</Typography>
          <Typography variant="p2" color="var(--color-i-gray-13)">
            We need your state to calculate final GST
          </Typography>
        </TopStateInfoWrapper>
        <DropDownWrapper $noOptionSelected={noOptionSelected}>
          <StyDropdown
            // @ts-ignore
            menuWidth="100%"
            menuHeight="337px"
            options={stateOptions}
            onOptionClick={(e) => setSelectedState(e.value)}
            selectedOption={stateOptions.find(
              (option) => option.value === selectedState
            )}
          />
        </DropDownWrapper>
        <StyButton
          // @ts-ignore
          label="Submit"
          disabled={noOptionSelected}
          onClick={submitStateSelection}
        />
      </CheckoutStateSelectWrapper>
    </>
  );
};

export default CheckoutStateSelect;
